//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Stores from "./components/Stores.vue";
import {loadYmap} from 'vue-yandex-maps'

const settings = {
    apiKey: process.env.yandexMapApiKey,
    lang: "ru_RU",
    coordorder: "latlong",
    version: "2.1",
};

export default {
    name: "StoresHome",
    emits: ["setStore"],
    props: [
        "yandexMapCoords",
        "getStores",
        "activeShop",
        "setStore",
        "onChangeSearch",
        "searchStore",
    ],
    components: {
        Stores
    },

    watch: {
        async getStores() {
            await this.yandexMapDestroy();
            this.yandexMapSetMarkers();
        },
        async activeShop() {
            await this.yandexMapDestroy();
            this.yandexMapSetMarkers();
        },
    },
    async mounted() {
        await this.yandexMapInit();
    },
    methods: {

        // Инициализация и удаление карты
        yandexMapInit: async function () {
            await loadYmap({...settings, debug: true});

            this.yandexMap = new ymaps.Map('yandex-map', {
                center: this.yandexMapCoords,
                zoom: 12,
                behaviors: ['drag', 'dblClickZoom', 'multiTouch']
            }, {
                maxZoom: 17
            });

            this.yandexMapSetMarkers();
        },
        yandexMapSetMarkers: function () {
            const yandexMap = this.yandexMap;
            const self = this;

            this.getStores.map((store) => {
                let MyIconContentLayout = ymaps.templateLayoutFactory.createClass(`<div class="store-map-pointer ${Boolean(this.activeShop === store.id || this.getStores.length === 1) ? ' store-map-pointer--active' : ''}"><span>${store.address}</span></div>`);
                let myPlacemarkWithContent = new ymaps.Placemark([store.lat, store.lon], {}, {
                    iconLayout: "default#imageWithContent",
                    iconImageHref: '',
                    content: "",
                    contentLayout: "",
                    imageSize: [60, 60],
                    imageOffset: [-30, -30],
                    contentOffset: [30, 20],
                    iconContentLayout: MyIconContentLayout
                })
                myPlacemarkWithContent.events.add('click', function () {
                    self.onTapMarker(store.id);
                });

                yandexMap.geoObjects.add(myPlacemarkWithContent);
            });

            yandexMap.setBounds(yandexMap.geoObjects.getBounds(), {checkZoomRange: true, zoomMargin: [160, 0]});
        },
        yandexMapDestroy: async function () {
            await this.yandexMap?.geoObjects?.removeAll();
        },

        // Клик по маркеру
        onTapMarker: function (id) {
            this.$emit("setStore", id);
        },
    },
};
